import React from 'react';
import './ClickableChevron.less';
var ClickableChevron = function () { return React.createElement("span", { className: "clickablechevron" },
    React.createElement("i", { className: "arrow" })); };
export default ClickableChevron;
